import React from 'react';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';

import ContentView from '../../components/ui-controls/layout/ContentView';
import {useTabBarBottomPadding} from '../../hooks/useTabBarBottomPadding';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import GiftCardPromotionExtraContent from '../articles/GiftCardPromotionExtraContent';

// Standalone "Participating Stores" screen. Renders the self-contained gift-card
// store-locator widget directly so it works in every navigator (including the gift
// card store, whose navigator excludes AppRoute.PROMOTION). The widget self-wires
// suburb search → store list, so no promotion object is required.
const GiftCardParticipatingStoresScreen = ({
  navigation,
}: RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_PARTICIPATING_STORES>) => {
  const tabBarPadding = useTabBarBottomPadding();
  return (
    <ContentView testID="gift-card-participating-stores-screen">
      {/* The widget renders a plain View (not a FlatList) and relies on an outer
          scroll container for the full result set. As a standalone screen we must
          supply that container ourselves — mirrors PromotionDetailScreen.
          KeyboardAwareScrollView (not plain ScrollView) so the suburb list, which
          renders as inline content below the postcode input, clears the on-screen
          keyboard instead of falling under it. DIS-1513. enableOnAndroid applies
          the keyboard inset on Android (manifest is adjustPan, which never resizes). */}
      <KeyboardAwareScrollView
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
        enableOnAndroid
        extraScrollHeight={40}
        contentContainerStyle={{paddingBottom: tabBarPadding}}>
        {/* hideBuyButton: this screen only confirms store availability — gift-card
            purchase entry points live in the gift card store and promotion. */}
        <GiftCardPromotionExtraContent navigation={navigation} hideBuyButton={true} />
      </KeyboardAwareScrollView>
    </ContentView>
  );
};

export default GiftCardParticipatingStoresScreen;
